// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__177K_","label":"styles_label__81amv"};